<template>
  <div id="listSports">
    <breadcrumbs v-if="!$route.params.event || !mobile" />
    <v-row no-gutters>
      <v-col
        cols="12"
        :md="!viewEvent ? 12 : 6"
        v-if="(mobile && !viewEvent) || !mobile"
      >
        <v-card
          class="pb-1 mt-2 colorDominant"
          elevation="0"
          outlined
          :class="{
            'mr-1': viewEvent && !mobile,
          }"
        >
          <ToolbarTabMarkets :type="'nextEvents'" />
          <v-progress-linear
            absolute
            indeterminate
            :active="loading"
          ></v-progress-linear>
          <Table :type="'nextEvents'" :data="data_events" />
          <div>
            <v-alert
              text
              dense
              :type="msg_error ? 'warning' : 'info'"
              border="left"
              class="ma-4 mb-2"
              v-if="msg_error || data_events.length == 0"
            >
              {{ msg_error ? msg_error : $t("loading") }}
            </v-alert>
          </div>
          <v-divider />
        </v-card>
      </v-col>
      <v-col cols="12" :md="mobile ? 12 : 6" v-if="viewEvent">
        <div :class="!mobile ? 'mt-2 ml-2' : ''">
          <v-toolbar dense class="colorDominant my-1" v-if="mobile">
            <div class="d-flex justify-space-between flex-grow-1">
              <v-btn icon @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <BottomSheetEvents />
              <GridOrlistOdds />
            </div>
          </v-toolbar>

          <router-view />
        </div>
      </v-col>
      <!-- DIALOG EVENT - DESCONTINUADO
        <template v-if="smAndDown">
        <v-dialog
          v-model="dialog"
          scrollable
          color="colorDominant"
          content-class="v-dialog--fullscreen"
          :retain-focus="false"
        >
          <v-toolbar absolute dense elevation="0" color="transparent">
            <v-btn
              @click="$router.go(-1)"
              depressed
              fab
              x-small
              color="rgba(255,255,255,0.20)"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <router-view />
        </v-dialog>
      </template> -->
    </v-row>
  </div>
</template>
<script>
import Table from "../events/components/table/table";
import breadcrumbs from "@/components/breadcrumbs/breadcrumbs";
import ToolbarTabMarkets from "../events/components/toolbar-markets";
import rulesOdds from "@/mixins/rulesOdds";
import BottomSheetEvents from "@/components/bottom-sheet-events/bottom-sheet-events.vue";
import GridOrlistOdds from "@/components/breadcrumbs/gridOrlistOdds.vue";
export default {
  name: "sports",
  mixins: [rulesOdds],
  components: {
    Table,
    ToolbarTabMarkets,
    breadcrumbs,
    BottomSheetEvents,
    GridOrlistOdds,
  },
  data: () => {
    return {
      data_events: [],
      loading: false,
      specialsEndpoints: {
        Brasil: "/player/table/listBrazil",
        Internacional: "/player/table/listInternacional",
        Europa: "/player/table/listEurope",
        "América do Sul": "/player/table/listSouthAmerica",
        UEFA: "/player/table/listUefa",
      },
      msg_error: "",
    };
  },
  computed: {
    innerSport() {
      return this.$store.state.innerSport;
    },
    viewEvent() {
      return this.$route.params.event ? true : false;
    },
    mobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isWorldCup() {
      return this.$route.params.tournament === 31004;
    },
  },
  mounted() {
    const replacements = {
      Brasil: this.$t("brazil"),
      Internacional: this.$t("international"),
      Europa: this.$t("europe"),
      "América do Sul": this.$t("southAmerica"),
    };
    let replacedItems = Object.keys(this.specialsEndpoints).map((key) => {
      const newKey = replacements[key] || key;
      return { [newKey]: this.specialsEndpoints[key] };
    });
    const itemsTranslate = replacedItems.reduce((a, b) =>
      Object.assign({}, a, b)
    );
    this.specialsEndpoints = itemsTranslate;
    this.$route.name != "special" ? this.getData() : this.getSpecial();
  },

  watch: {
    // Reações do componente quando instanciado filhos na sua rota.
    $route(newRoute, oldRoute) {
      // console.log(newRoute);
      // console.log(oldRoute);
      const categoryRoutes = ["category", "BetSuccessEventsCategory"];
      const tournamentRoutes = ["tournament", "BetSuccessTournament"];

      // When Call getData and getSpecial:
      if (categoryRoutes.includes(this.$route.name) && !this.mobile) {
        this.getData();
        return;
      }

      if (
        tournamentRoutes.includes(this.$route.name) &&
        oldRoute.name !== "category" &&
        !this.mobile
      ) {
        this.getData();
        return;
      }

      if (
        tournamentRoutes.includes(oldRoute.name) &&
        categoryRoutes.includes(oldRoute.name) &&
        !this.mobile
      ) {
        this.getData();
        return;
      }

      if (
        tournamentRoutes.includes(this.$route.name) &&
        categoryRoutes.includes(oldRoute.name) &&
        !this.mobile
      ) {
        this.getData();
        return;
      }

      if (this.$route.name === "special" && !this.mobile) {
        this.getSpecial();
        return;
      }

      if (this.$route.query.search && !this.mobile) {
        this.getData();
        return;
      }

      // Mobile:
      if (this.mobile) {
        if (
          !(
            oldRoute.name == "eventsCategory" ||
            newRoute.name == "eventsCategory"
          ) &&
          !(
            oldRoute.name == "eventsSpecial" || newRoute.name == "eventsSpecial"
          ) &&
          !(
            oldRoute.name == "eventsTournament" ||
            newRoute.name == "eventsTournament"
          )
        ) {
          if (
            (newRoute.name == "tournament" ||
              newRoute.name === "BetSuccessTournament" ||
              oldRoute.name == "tournament" ||
              oldRoute.name === "BetSuccessTournament") &&
            !(newRoute.name == "special")
          ) {
            this.getData();
            return;
          }

          if (
            (categoryRoutes.includes(newRoute.name) ||
              categoryRoutes.includes(oldRoute.name)) &&
            !(newRoute.name == "special")
          ) {
            this.getData();
            return;
          }

          if (
            (newRoute.name == "special" || oldRoute.name == "special") &&
            !(
              tournamentRoutes.includes(newRoute.name) ||
              categoryRoutes.includes(newRoute.name)
            )
          ) {
            this.getSpecial();
            return;
          }
        }
      }
    },
  },
  methods: {
    getData: function() {
      this.loading = true;
      let id_sport = this.$route.params.sport;
      let id_category = this.$route.params.category;
      let id_tournament = this.$route.params.tournament;

      if (
        this.$route.query.liveEvent == undefined ||
        this.$route.query.liveEvent == "false" ||
        this.$route.query.liveEvent == false
      ) {
        const url =
          id_tournament == "" || id_tournament == null
            ? "/player/table/eventsByCategory"
            : this.isWorldCup
            ? "/tableMain/tournamentsSpecials"
            : "/player/table/eventsByTournament";
        const data =
          id_tournament == "" || id_tournament == null
            ? { id_sport, id_category, domain: this.$domain() }
            : this.isWorldCup
            ? { "tournaments[0]": 31004, domain: this.$domain() }
            : { id_tournament, domain: this.$domain() };

        this.request(url, data);
        // this.$isAgent()
        //   ? this.filterInner(id_category, id_tournament, id_sport)
        //   : this.request(url, data);
      }
    },

    getSpecial: function() {
      this.loading = true;
      // this.data_events = [];

      // console.log("query", this.$route.query.category);

      const endPoint = this.specialsEndpoints[this.$route.query.category];
      const data = { domain: this.$domain() };
      this.request(endPoint, data);
    },

    request: function(url, data) {
      this.$axios
        .post(url, this.$formdata(data))
        .then(async (resp) => {
          if (this.$route.name === "special") {
            const data = resp.data.sports[0].categories;
            await this.editDataSports(data);
            this.data_events = data;
          } else {
            const data = [resp.data];
            // const eventsFiltredBySport = await this.editDataSports(data);
            await this.editDataSports(data);
            this.data_events = data;
          }

          this.msg_error = false; // reset
        })
        .catch((error) => {
          this.data_events = [];
          this.msg_error = error.response.data.messages["error"];
          const msg = this.msg_error;
          const color = "warning";
          this.$store.commit("setNotification", { msg, color });
        })
        .finally(() => (this.loading = false));
    },

    // Filtro do agente
    filterInner(category, tournament, sport) {
      if (this.innerSport != sport) {
        this.$store.commit("innerSport", sport);
        this.loading = true;
        const objInner = { id_esporte: sport };
        this.$axios
          .post("/agent/table/inner", this.$formdata(objInner))
          .then(async (resp) => {
            const data = resp.data.dados.categories;
            await this.editDataSports(data);
            const data_events = {
              all: data,
              filtred: [],
            };

            await this.$store.commit("data_events", data_events);
            await localStorage.setItem(
              "data_events",
              JSON.stringify(data_events)
            );
            // if (category == "") return;
            await this.filterInnerbyCategory(category, tournament);
          })
          .finally(() => (this.loading = false));
      } else {
        this.filterInnerbyCategory(category, tournament);
      }
    },

    filterInnerbyCategory(category, tournament) {
      const data = JSON.parse(localStorage.data_events);
      const categoryFiltred = data.all.filter((item) => item.id == category);

      this.filtred = { ...categoryFiltred[0] };

      if (tournament != "" && tournament != undefined) {
        this.filtred.tournaments = this.filtred.tournaments.filter(
          (t) => t.id == tournament
        );
      }

      this.data_events = [this.filtred];
      this.loading = false;
    },
  },
};
</script>
